// /**
//  * Centers - Detail
//  */

// React
import React, { useEffect, useState } from 'react';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Store } from '../../../redux/reducers';
import {
  getUsersByCenterIdAction,
  getUsersBeAdminCenterAction,
  updateCenterAdminActions,
} from '../actions';

// Selector
import { createStructuredSelector } from 'reselect';
import {
  makeSelectList,
  makeSelectError,
  makeSelectLoading,
  makeSelectCountList,
  makeSelectUsersListByCenterId,
  makeSelectUsersListBeCenter,
} from '../selectors';

import { getCentersAction, getCentersWithIdAction } from '../actions';

// UI
import {
  Paper,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Card,
  CardHeader,
  CardContent,
  Typography,
} from '@material-ui/core';
import classes from './detail.module.scss';

// Helper
import { formaterPhoneNumber, translate } from '../../../utils/helpers';
import { removeEmptyValueObject } from '../../../utils/helpers';
import useQuery from '../../../utils/hook/useQuery';
import windowSize from '../../../utils/hook/useWindowResize';

// Components
import AddUser from './add-user';
import DetailMobile from '../mobileView/components/detail';

// Type
// import {SelectorPropsDetail, PropsDetail, PayloadUpdate} from '../interfaces';
import { PropsDetail, SelectorPropsDetail, PayloadUpdate } from '../interfaces';
import centersRepository from 'client-sdk/src/Repository/centers-repository';
import handleError from '../../../utils/handleError';
import usersRepository from 'client-sdk/src/Repository/users-repository';
import TicketLink from '../../../components/ticketLink';
import RonadIcons from '../../../components/iconComponent';

function Detail(props: PropsDetail) {
  const [openAddUser, setOpenAddUser] = useState(false as boolean);
  const [openMap, setOpenMap] = useState(false as boolean);
  const { filtersValues, setFiltersValues } = useQuery({
    page: 0,
    size: 10,
  });
  const [centerList, setCenterList] = useState([])
  const [userList, setUserList] = useState([])
  const [isMob, setIsMob] = useState(false);
  const { width } = windowSize();

  useEffect(() => {
    getCenters();
  }, [props.match.params]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (width && width <= 480) {
      setIsMob(true);
    } else {
      setIsMob(false);
    }
  }, [width]);

  const getCenters = async () => {
    const { page, size } = filtersValues;
    const { partnerId, warehousesId } = props.match.params;
    try {
      const centers = await centersRepository.getCenters({
        payload: {
          ...removeEmptyValueObject(filtersValues),
          warehousesId: { equals: warehousesId },
          partnerId: { equals: partnerId },
          page,
          size,
        }
      })
      const users = await usersRepository.getUsers({
        payload: {
          'centersId.equals': props.match.params?.centerId,
        }
      })
      setCenterList(centers.response.data)
      setUserList(users.response.data)
    } catch (error) {
      handleError(error)
    }
  };

  const handleClose = () => {
    setOpenAddUser(false);
  };

  const data = centerList.find(
    center => center.id == props.match.params?.centerId
  );
  return (
    <>
      <Grid
        className={classes.topBox}
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Paper
          elevation={1}
          style={{
            width: '100%',
            borderRadius: '0',
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <div className={classes.headerBox}>
            <Typography variant="h6" component="h2">
              جزییات مرکز
              <span> &nbsp; {data?.name}</span>
            </Typography>
          </div>
          <span style={{ marginLeft: '130px', marginRight: 'auto' }}>
            <TicketLink />
          </span>
        </Paper>
      </Grid>
      <Grid container md={12} lg={12} spacing={4}>
        <Grid item md={3} lg={3} xs={12} spacing={3}>
          <Card className={classes.card}>
            <CardHeader
              avatar={
                <Typography className={classes.typographyCards}>
                  اطلاعات مرکز
                </Typography>
              }
            />
            <CardContent style={{ paddingBottom: '10px' }}>
              <Grid item xs={12} sm={12} lg={12}>
                <div className={classes.item}>
                  <span className={classes.label}> {`نام مرکز:  `}</span>

                  <span>{data?.name}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}> {`کد مرکز:  `}</span>

                  <span>{data?.code}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}> {`شماره تماس:  `}</span>

                  <span>{formaterPhoneNumber(data?.phoneNumber)}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}> {`وضعیت مرکز:  `}</span>

                  <span>{translate(data?.status, 'center')}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}> {` استان:  `}</span>

                  <span>{data?.province}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}> {` شهر:  `}</span>

                  <span>{data?.city}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label}> {` کد پستی:  `}</span>
                  <span>{data?.zipCode}</span>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={classes.item}>
                  <span className={classes.label} style={{ alignSelf: 'start' }}>
                    {' '}
                    {` آدرس:  `}
                  </span>
                  <span style={{ textAlign: 'left', marginRight: '30px' }}>
                    {data?.address}
                  </span>
                </div>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid item md={9} lg={9} spacing={3}>
        </Grid>
      </Grid>
      <Dialog
        fullScreen
        open={openAddUser}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div>{`اختصاص کاربر به شرکت ${data?.name}`}</div>
          <Button aria-label="details" size="medium" onClick={handleClose}>
            <RonadIcons name='chevronRight'/>
            {`بازگشت`}
          </Button>
        </DialogTitle>
        <DialogContent>
          <AddUser
            handleClose={handleClose}
            usersList={props.usersBeAdminCenter}
            usersBeAdminCenterDispatch={props.usersBeAdminCenterDispatch}
            updateCenterDispatch={props.updateCenterAdminDispatch}
            centerId={props.match.params.centerId}
          />
        </DialogContent>
      </Dialog>

      <Dialog open={openMap} onClose={() => setOpenMap(false)}>
        <DialogTitle>آدرس مرکز روی نقشه </DialogTitle>
        {/* <DialogContent style={{width: '600px'}}>
          <MapPosition
            zoom={14}
            center={[props.data.lat, props.data.lon]}
            position={[props.data.lat, props.data.lon]}
            setLatlng={(latLng: {lat: number; lng: number}) => null}
          />
        </DialogContent> */}
      </Dialog>
    </>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorPropsDetail>({
  centersList: makeSelectList(),
  usersByCenterId: makeSelectUsersListByCenterId(),
  usersBeAdminCenter: makeSelectUsersListBeCenter(),
  count: makeSelectCountList(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    centersDispatch: (payload: Object) => dispatch(getCentersAction(payload)),

    centersWithIdDispatch: (payload: Object) =>
      dispatch(getCentersWithIdAction(payload)),

    usersByCenterIdDispatch: (payload: Object) =>
      dispatch(getUsersByCenterIdAction(payload)),
    usersBeAdminCenterDispatch: (payload: Object) =>
      dispatch(getUsersBeAdminCenterAction(payload)),
    updateCenterAdminDispatch: (payload: PayloadUpdate) =>
      dispatch(updateCenterAdminActions(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Detail);
